import { SpinnerButton } from 'spa/components/button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { FormattedMessage } from 'react-intl'
import { defineMessages, injectIntl } from 'react-intl'
import { Loading } from 'spa/components/loading'
import { FORGOT_PASSWORD_MODAL, openModal } from 'spa/action_creators/modals'
import { useDispatch, useSelector } from 'react-redux'
import { Label } from 'spa/components/label'
import classNames from 'classnames'
import { login } from 'spa/action_creators/current_user'
import { TextInput } from 'spa/components/text_input'
import PropTypes from 'prop-types'
import React, { useState, useCallback } from 'react'
import styles from './styles'

const localizedMessages = defineMessages({
  email: {
    id: 'djcity.account.login.email',
    defaultMessage: 'Email Address',
  },
  password: {
    id: 'djcity.account.login.password',
    defaultMessage: 'Password',
  },
})

function SunsetLogin({ intl }) {
  const dispatch = useDispatch()
  const isLoggingIn = useSelector(state => state.isLoggingIn)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [passwordHidden, setPasswordHidden] = useState(true)

  const onForgotPasswordClick = useCallback(() => {
    dispatch(openModal(FORGOT_PASSWORD_MODAL))
  }, [dispatch])

  const isDisabled = !username || !password || isLoggingIn

  const onSubmit = useCallback(
    e => {
      e.preventDefault()
      if (!isDisabled) {
        dispatch(
          login({
            username,
            password,
          })
        )
      }
    },
    [isDisabled, username, password]
  )

  const isLoadingResources = useSelector(
    state => state.stringResources.isFetching
  )

  if (isLoadingResources) return <Loading intl={intl} withHelp={true} />

  return (
    <form className={styles.loginForm} onSubmit={onSubmit}>
      <Label
        className={styles.label}
        text={intl.formatMessage(localizedMessages.email)}
      >
        <TextInput
          className={styles.input}
          onChange={e => setUsername(e.currentTarget.value)}
          value={username}
        />
      </Label>
      <Label
        className={styles.label}
        text={intl.formatMessage(localizedMessages.password)}
      >
        <TextInput
          className={classNames(styles.input, styles.passwordInput)}
          onChange={e => setPassword(e.currentTarget.value)}
          type={passwordHidden ? 'password' : 'text'}
          value={password}
        />
        <FontAwesomeIcon
          className={styles.password}
          icon={passwordHidden ? 'eye-slash' : 'eye'}
          onClick={() => setPasswordHidden(!passwordHidden)}
        />
      </Label>
      <button
        className={classNames('cleanButton', styles.forgotPassword)}
        onMouseDown={onForgotPasswordClick}
      >
        <FormattedMessage
          defaultMessage="Forgot Password"
          id="djcity.account.login.forgot_password"
        />
      </button>
      <SpinnerButton
        centered="centered"
        disabled={isDisabled}
        loading={isLoggingIn}
        type="submit"
      >
        <FormattedMessage
          defaultMessage="Login"
          id="djcity.account.login.login"
        />
      </SpinnerButton>
    </form>
  )
}

SunsetLogin.propTypes = {
  intl: PropTypes.object,
}

export default injectIntl(SunsetLogin)
